var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{attrs:{"dir":_vm.lang == 'en' ? 'ltr' : 'rtl'}},[(_vm.isLoggedIn)?_c('div',{attrs:{"id":"content"}},[(_vm.isLoggedIn)?_c('NavBar'):_vm._e(),(_vm.isLoggedIn)?_c('SideBar'):_vm._e(),_c('v-container',{class:!_vm.getSideBarMin &&
          (_vm.lang == 'undefined' || _vm.lang == undefined || _vm.lang == 'en')
            ? 'active'
            : _vm.lang == 'ar' && !_vm.getSideBarMin
            ? 'activeRtl'
            : '',attrs:{"id":"wrapper"}},[_c('router-view')],1)],1):_c('div',{attrs:{"id":"content"}},[_c('v-container',{staticStyle:{"max-width":"100% !important"},attrs:{"id":"","fluid":""}},[_c('router-view')],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }